import { useEffect, useRef } from 'react';

const useInitialRender = () => {
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    }
  });

  return firstRender.current;
};

export default useInitialRender;
